module.exports = "/fonts/vendor/lightcase/src/lightcase.woff?30cce75077e855a9f9c53b2ba6e76c4d";


//////////////////
// WEBPACK FOOTER
// ./node_modules/lightcase/src/fonts/lightcase.woff?55356177
// module id = 301
// module chunks = 1 2